import React from 'react'
import styled, { keyframes, css } from 'styled-components'

import { Text, getPaletteColor } from 'pcln-design-system'

const bounce = keyframes`
  0% { transform: translateY(0); }
  20% { transform: translateY(0); }
  40% { transform: translateY(-2px); }
  50% { transform: translateY(0); }
  60% { transform: translateY(-1px); }
  80% { transform: translateY(0); }
  100% { transform: translateY(0); }
`

const bounceRule = css`
  ${bounce};
`

const BounceDot = styled.span`
  content: '';
  width: 2px;
  height: 2px;
  background-color: ${(props) => getPaletteColor(props.color)(props)};
  border-radius: 100%;
  display: inline-block;

  animation-duration: 1s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-name: ${bounceRule};

  &:nth-child(3) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: -0.33s;
  }

  &:nth-child(1) {
    animation-delay: -0.66s;
  }
`

class LoadingText extends React.Component {
  render() {
    const { color = 'background.darkest' } = this.props
    return (
      <Text color={color} align={'center'}>
        Loading <BounceDot color={color} /> <BounceDot color={color} /> <BounceDot color={color} />
      </Text>
    )
  }
}

export { LoadingText }
